/**
 * Intensives page initialization
 * Initializes the location gallery Swiper carousel (if present)
 */

import { createSwiperGallery } from '../../components/swiper-gallery.js';
import { domReady } from '../../utils/dom.js';

function initIntensivesGallery() {
  // createSwiperGallery expects an element ID without "#"
  // and it already no-ops if the element doesn't exist.
  try {
    createSwiperGallery('swiper-2');
  } catch (err) {
    console.error('❌ Failed to initialize Intensives gallery:', err);
  }
}

domReady(initIntensivesGallery);
